import { collection, deleteDoc, doc, onSnapshot, query} from 'firebase/firestore';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import { Link } from 'react-router-dom';
import { db } from '../firebase';

const ShowNotice = () => {
    const [noticeList,setNoticeList] = useState([]);


    useEffect(()=>{
        const q = query(collection(db, "noticeAll"));
    onSnapshot(q, (querySnapshot) => {
      let noticeArray = [];
      querySnapshot.forEach((doc) => {
        noticeArray.push({ id: doc.id, ...doc.data() });
      });
      setNoticeList(noticeArray);
    });
    },[])

    const deleteNotice = async (nid) => {
      await deleteDoc(doc(db, "noticeAll", nid));
      console.log("Deleted ===>" + nid);
    };


  return (
    <React.Fragment>
    <div className="p-5  min-h-screen">
    <h1 className="text-left mb-4 ml-2 text-3xl font-semibold">
    All Notice
    </h1>
    <table className="w-full text-center">
      <thead className="border-b">
        <tr className="bg-gray-100">
          <th className="py-3 "> Sl No.</th>
          <th className="py-3 ">Notice Date</th>
          <th className="py-3 ">Notice Title</th>
          <th className="py-3 ">View</th>
          <th className="py-3 ">Update</th>
          <th className="py-3 ">Delete</th>
        </tr>
      </thead>
      <tbody>
        {noticeList?.map((item,index)=>(
        <tr className='border-b' key={index}>
            <td className='border-r border-l'>{++index}</td>
            <td className='border-r'>{item.noticeDate}</td>
            <td className='border-r'>{item.noticeTitle}</td>
            <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../noticeBoard"} state={{ noticeId: item.id }}>
                    <button className="text-white bg-yellow-600 py-1 px-6 rounded-md">
                      View
                    </button>
                  </Link>
                </td>
                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../updateNotice"} state={{noticeId:item.id}}>
                <button
                     className="text-white ml-10 bg-green-600 py-1 px-1 rounded-md">
                  Update</button>
                  </Link>
                </td>                
                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-red-600 py-1 px-6 rounded-md "
                    onClick={() => deleteNotice(item.id)}
                  >
                    Delete
                  </button>
                </td>
        </tr>
        ))}
      </tbody>
    </table>  
     
  </div> 
  </React.Fragment>
  )
}

export default ShowNotice